import {
  Divider,
  Grid,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Stack,
  useBreakpointValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { AzkarSection, CustomHeader, QariItem, SurahItem } from "components";
import { useTranslation } from "languages";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "tools/store";
import { getSelectedSurah, setSelectedSurah } from "../non_persist_slice";

const Dashboard: React.FC = () => {
  const { isArabic } = useTranslation();

  const dispatch = useAppDispatch();

  const selectedSurah = useAppSelector(getSelectedSurah);
  // const [audioUrl, setAudioUrl] = useState<string>("");
  // const [isBuffering, setIsBuffering] = useState<boolean>(false);
  // const selectedItem = useAppSelector(getSelectedItem);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [search, setSearch] = useState("");
  const [qariList, setQaris] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isQariLoad, setQariLoad] = useState(false);
  const [isSurahLoad, setSurahLoad] = useState(false);
  const [qariDetail, setQariDetail] = useState<any>({});
  const [selectedQari, setSelectedQari] = useState<any>({});
  const [surahList, setSurahs] = useState<any[]>([]);

  const handleSetSurah = (it: any) => {
    const body: any = {
      currentSurahNumber: it?.number,
      surahList,
      qariDetail: qariDetail,
      ...it,
    };
    dispatch(setSelectedSurah(body));
  };

  // console.log("=--=--=-=-=", qariDetail.highestElement.surah_list);

  useEffect(() => {
    setSurahLoad(true);
    fetch("https://api.alquran.cloud/v1/surah")
      .then((res) => res.json())
      .then((res) => {
        if (res?.data && res?.data.length > 0) {
          setSurahs(res?.data);
        }
        setSurahLoad(false);
      })
      .catch((e) => {
        setSurahLoad(false);
        console.log("=-=-=-=-=", e);
      });
  }, []);

  useEffect(() => {
    const fetchQariDetail = (id: string) => {
      setQariLoad(true);
      fetch(
        `https://www.mp3quran.net/api/v3/reciters?language=${
          isArabic ? "ar" : "eng"
        }&reciter=${id || 1}`
      )
        .then((res) => res.json())
        .then((res) => {
          if (res?.reciters && res?.reciters.length > 0) {
            let obj = res?.reciters[0];
            const highestElement = (obj?.moshaf || []).reduce(
              (maxItem: any, currentItem: any) =>
                currentItem.surah_total > maxItem.surah_total
                  ? currentItem
                  : maxItem
            );
            const surah_list = highestElement?.surah_list?.split(",");
            obj = { ...obj, highestElement: { ...highestElement, surah_list } };
            setQariDetail(obj);
          }
          setQariLoad(false);
        })
        .catch((e) => {
          setQariLoad(false);
          console.log("=-=-=-=-=", e);
        });
    };

    fetchQariDetail(selectedQari?.id);
  }, [selectedQari?.id, isArabic]);

  useEffect(() => {
    setLoading(true);
    fetch(
      `https://www.mp3quran.net/api/v3/reciters?language=${
        isArabic ? "ar" : "eng"
      }`
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        // console.log("=-=-=-=", res?.reciters)
        if (res?.reciters && res?.reciters.length > 0) {
          setQaris(res?.reciters);
          setSelectedQari(res?.reciters[0]);
        }
      })
      .catch((e) => {
        setLoading(false);
        console.log("=-=-=-=-=", e);
      });
  }, [isArabic]);

  // if (isFetching || isBookmarkLoad || isCreatingBookmarks || isCreatingNotes) {
  //   return <Spinner size="xl" position={"absolute"} top={"50%"} left={"50%"} />;
  // }

  // if (isFetching || isBookmarkLoad || isCreatingBookmarks || isCreatingNotes) {
  //   return <Spinner size="xl" position={"absolute"} top={"50%"} left={"50%"} />;
  // }

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <Stack pb={10} px={[2, 10]} h={"full"}>
      <CustomHeader />

      <HStack
        align={"self-start"}
        w="100%"
        h="calc(100% - 30px)"
        flexDirection={isArabic ? "row-reverse" : undefined}
      >
        {layoutDirection === "row" && (
          <QariSection
            onChange={setSearch}
            onCallback={setSelectedQari}
            search={search}
            isLoading={isLoading}
            qariList={qariList}
            selectedQari={selectedQari}
          />
        )}

        {isQariLoad || isSurahLoad ? (
          <VStack
            w={["100%", "70%"]}
            h="full"
            bgColor={"secondary.900"}
            borderRadius={"xl"}
            align={"center"}
            justify={"center"}
          >
            <Spinner size="xl" />
          </VStack>
        ) : (
          <VStack
            w={["100%", "70%"]}
            align={"flex-start"}
            h="full"
            bgColor={"secondary.900"}
            p={[2, 4]}
            borderRadius={"xl"}
          >
            <HStack w={"full"}>
              {/* {layoutDirection === "row" && (
                <HStack gap={5} w="40%">
                  <Avatar
                    name={qariDetail?.name}
                    size="xl"
                    border={"2px solid var(--chakra-colors-primary-300)"}
                  />
                  <Heading noOfLines={3} fontSize={"3xl"}>
                    {qariDetail?.name}
                  </Heading>
                </HStack>
              )} */}

              <AzkarSection />
            </HStack>

            <Divider my={[0, 2]} />

            {layoutDirection === "column" && (
              <>
                <QariItem
                  isIcon={false}
                  qari={selectedQari}
                  isSelected={true}
                  onCallback={onOpen}
                />

                <Modal isOpen={isOpen} onClose={onClose}>
                  <ModalOverlay backdropFilter="blur(5px)" />
                  <ModalContent
                    bg="secondary.300"
                    borderRadius="3xl"
                    m={2}
                    boxShadow="lg"
                    maxW={"96%"}
                    h={"96%"}
                  >
                    <ModalCloseButton />
                    <ModalBody p={0} h="full">
                      <QariSection
                        onChange={setSearch}
                        onCallback={(val) => {
                          setSelectedQari(val);
                          onClose();
                        }}
                        search={search}
                        isLoading={isLoading}
                        qariList={qariList}
                        selectedQari={selectedQari}
                      />
                    </ModalBody>
                  </ModalContent>
                </Modal>
              </>
            )}

            <Grid
              templateColumns={`repeat(${
                layoutDirection === "column" ? "1" : "3"
              }, 1fr)`}
              gap={[2, 4]}
              w="100%"
              h="full"
              overflowY="auto"
              className="mac-scrollbar"
            >
              {(surahList || [])
                .filter((item: any) => {
                  const findSurahIndex =
                    qariDetail?.highestElement?.surah_list.findIndex(
                      (surahumber: any) => Number(surahumber) === item?.number
                    );

                  return findSurahIndex > -1;
                })
                .map((it, index) => {
                  // const isSelected =
                  //   it?.number === selectedSurah?.currentSurahNumber &&
                  //   qariDetail?.id === selectedSurah?.qariDetail?.id;

                  const isSelected =
                    it?.number === selectedSurah?.currentSurahNumber;

                  return (
                    <SurahItem
                      key={index}
                      surah={it}
                      isSelected={isSelected}
                      onCallback={() => handleSetSurah(it)}
                    />
                  );
                })}
            </Grid>
          </VStack>
        )}
      </HStack>
    </Stack>
  );
};

export default Dashboard;

const QariSection: React.FC<{
  onChange: (val: string) => void;
  onCallback: (val: any) => void;
  search: string;
  isLoading: boolean;
  qariList: any;
  selectedQari: any;
}> = ({ onChange, search, isLoading, qariList, selectedQari, onCallback }) => {
  const { translation, isArabic } = useTranslation();

  const searchIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
    >
      <g id="Group_14050" data-name="Group 14050">
        <path
          id="Vector"
          d="M8.106,0A8.115,8.115,0,1,1,2.377,2.377,8.106,8.106,0,0,1,8.106,0Zm0,14.975a6.878,6.878,0,1,0-4.855-2.014A6.869,6.869,0,0,0,8.106,14.975Z"
          fill="#bf8d46"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M2.194,2.813a.616.616,0,0,1-.437-.181L.181,1.055A.618.618,0,0,1,1.055.181L2.632,1.757a.619.619,0,0,1-.438,1.055Z"
          transform="translate(14.187 14.187)"
          fill="#bf8d46"
        />
      </g>
    </svg>
  );

  return (
    <VStack
      align={isArabic ? "self-end" : "self-start"}
      w={["100%", "30%"]}
      h="full"
      bgColor={"secondary.900"}
      p={[2, 4]}
      borderRadius={"xl"}
    >
      <Heading fontSize={"2xl"}>{translation["search_qari"]}</Heading>

      <InputGroup
        bgColor={"secondary.300"}
        borderColor={"transparent"}
        borderRadius={"xl"}
      >
        {isArabic ? (
          <InputRightElement pointerEvents="none" h={"100%"}>
            {searchIcon}
          </InputRightElement>
        ) : (
          <InputLeftElement pointerEvents="none" h={"100%"}>
            {searchIcon}
          </InputLeftElement>
        )}

        <Input
          type="text"
          name="email"
          textAlign={isArabic ? "right" : "left"}
          placeholder={translation["search_"]}
          onChange={(val) => onChange(val.currentTarget.value)}
          value={search}
          borderRadius={10}
        />
      </InputGroup>

      <Heading fontSize={"2xl"} mt={[2, 6]}>
        {translation["popular_qari"]}
      </Heading>

      {isLoading ? (
        <VStack w="full" h={"full"} align={"center"} justify={"center"}>
          <Spinner size="xl" />
        </VStack>
      ) : (
        <VStack w="full" h={"full"} overflowY="auto" className="mac-scrollbar">
          {qariList
            .filter((it: any) =>
              it?.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
            )
            .map((it: any, index: number) => (
              <QariItem
                key={index}
                qari={it}
                // isSelected={it?.id === qariDetail?.id}
                isSelected={it?.id === selectedQari?.id}
                onCallback={() => onCallback(it)}
              />
            ))}
        </VStack>
      )}
    </VStack>
  );
};
